import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import AdminLayout from "@/components/AdminLayout";
import { PageHeader } from "@/components/ui-system";
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import WebhookConfig from "@/components/b2c/WebhookConfig";
import { toast } from "sonner";
import { Webhook } from "lucide-react";

const B2CWebhooks = ({ user, onLogout }) => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sellerId, setSellerId] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/admin/sellers`)
      .then((r) => setSellers((Array.isArray(r.data) ? r.data : []).filter((s) => s.b2c_enabled)))
      .catch(() => toast.error("Failed to load sellers"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout user={user} onLogout={onLogout}>
      <div className="space-y-6 w-full max-w-3xl">
        <PageHeader
          title="Tracking Webhooks"
          subtitle="Configure a per-seller tracking-update webhook on a seller's behalf"
        />

        <Card className="border-0 shadow-sm">
          <CardContent className="pt-6">
            <div className="space-y-1.5 max-w-sm">
              <Label className="text-xs text-slate-600">Seller</Label>
              <Select value={sellerId} onValueChange={setSellerId}>
                <SelectTrigger data-testid="webhook-seller-picker">
                  <SelectValue placeholder={loading ? "Loading sellers…" : "Select a B2C-enabled seller"} />
                </SelectTrigger>
                <SelectContent>
                  {sellers.map((s) => (
                    <SelectItem key={s.seller_id} value={s.seller_id}>
                      {s.brand_name || s.company_registered_name || s.seller_id}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </CardContent>
        </Card>

        {sellerId ? (
          <WebhookConfig key={sellerId} sellerId={sellerId} />
        ) : (
          <div className="flex items-center gap-2 text-sm text-slate-500 rounded-lg border border-dashed border-slate-200 p-6 justify-center">
            <Webhook className="w-4 h-4 text-slate-400" /> Select a seller to configure their tracking webhook.
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default B2CWebhooks;
